<template>
  <Popover
    v-bind="$attrs"
    :trigger-attrs="triggerAttrs"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #content="{ close }">
      <div
        class="dropdown-menu MenuPopover"
        role="menu"
      >
        <template
          v-for="item in shown"
          :key="item.key"
        >
          <div
            v-if="item.divider"
            role="separator"
            class="dropdown-divider"
          />
          <div
            v-else-if="item.heading"
            class="menu-heading"
            aria-hidden="true"
          >
            {{ item.heading }}
          </div>
          <slot
            v-else-if="item.slot"
            :name="item.slot"
            :close="close"
          />
          <div
            v-else
            class="menu-item dropdown-item"
            :class="rowClass(item)"
          >
            <button
              class="main-button"
              type="button"
              :role="role(item)"
              :aria-checked="ariaChecked(item)"
              :disabled="item.disabled"
              @click="run(item, close)"
            >
              <span
                v-if="drawsMark(item)"
                class="input menu-checkbox"
                :class="{
                  '-radio': item.radio,
                  'menu-checkbox-checked': item.checked === true,
                  'menu-checkbox-indeterminate': item.checked === 'mixed',
                }"
                aria-hidden="true"
              />
              <FAIcon
                v-if="item.icon"
                :icon="item.icon"
                fixed-width
                aria-hidden="true"
              />
              <span class="menu-label">
                {{ item.label }}
                <small
                  v-if="item.description"
                  class="menu-description"
                >{{ item.description }}</small>
              </span>
            </button>
          </div>
        </template>
      </div>
    </template>
  </Popover>
</template>

<script src="./menu_popover.js"></script>

<style lang="scss">
.MenuPopover {
  .menu-heading {
    padding: 0.25em 0.75em 0.15em;
    font-size: var(--fs-sm);
    color: var(--textFaint);
  }

  .menu-description {
    display: block;
    color: var(--textFaint);
    font-size: var(--fs-sm);
    line-height: 1.3;
    white-space: normal;
  }

  .-danger .main-button {
    color: var(--cRed);
  }
}
</style>
